module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/setouchi_prize_2201-fb116c05ac3540bf286bc14935f5974f.jpg";